import { render, staticRenderFns } from "./MshiptypesGrid.vue?vue&type=template&id=3385061e"
import script from "./MshiptypesGrid.vue?vue&type=script&lang=js"
export * from "./MshiptypesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports